<template>
  <div class="sns-share-buttons">
    <div class="sns-share-button__counts">{{ shareCounts }}件</div>
    <div class="sns-share-buttons__buttons d-flex">
      <a
        :href="'https://www.facebook.com/sharer/sharer.php?u=' + pageurl"
        onclick="window.open(this.href, 'window ','width = 550, height = 450, personalbar = 0, toolbar = 0, scrollbars = 1, resizable = 1 '); return false;"
      >
        <img
          class="hero_img"
          src="https://www.mag2.com/events/mag2year/2019/images/Facebook.png"
        />
      </a>
      <a
        :href="
          'https://twitter.com/intent/tweet?url=' +
            pageurl +
            '&text=まぐまぐ大賞2020 結果発表!!' +
            '&hashtags=まぐまぐ大賞2020'
        "
        onclick="window.open(encodeURI(decodeURI(this.href)), ' tweetwindow ', ' width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=1 ' ); return false;'"
      >
        <img
          class="hero_img"
          src="https://www.mag2.com/events/mag2year/2019/images/Twitter.png"
        />
      </a>
      <!-- <a
                      class="col-3"
                        :href="
                          'https://b.hatena.ne.jp/amode=confirm&url=https://www.mag2.com/events/mag2year/2020/category/' +
                          item.categoryId +
                          '.html&title=' +
                          item.magazineTitle +
                          ' - まぐまぐ大賞2020結果発表ページ'
                        "
                        target="_blank"
                      >
                        <img
                          class="hero_img"
                          src="https://www.mag2.com/events/mag2year/2019/images/Hatebu.png"
                        />
                      </a> -->
      <a :href="'https://social-plugins.line.me/lineit/share?url=' + pageurl">
        <img
          style="margin-right: 0"
          class="hero_img"
          src="https://www.mag2.com/events/mag2year/2019/images/Line.png"
        />
      </a>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {},
  data: function() {
    return {
      shareCounts: 0
    }
  },
  mounted() {
    this.updateShareCounts()
  },
  methods: {
    updateShareCounts() {
      //const url = 'https://www.mag2.com/events/mag2year/2020/'
      const url = this.pageurl
      axios
        .get('https://jsoon.digitiminimi.com/twitter/count.json?url=' + url)
        .then((response) => {
          var counts = response.data.count + response.data.likes
          this.shareCounts = counts
        })
    }
  },
  computed: {
    pageurl() {
      return 'https://' + window.location.hostname + window.location.pathname
    }
  }
}
</script>

<style scoped>
.sns-share-buttons {
  text-align: center;
  margin: 20px auto;
  border-top: 1px solid rgb(119, 119, 119);
  border-bottom: 1px solid rgb(119, 119, 119);
  padding: 20px;
}

.sns-share-buttons a {
  margin-right: 10px;
}
.sns-share-buttons a:last-child {
  margin-right: 0px;
}
.sns-share-buttons__buttons {
  justify-content: center;
}

.sns-share-button__counts {
  background-color: #fff;
  border: 1px solid #777;
  border-radius: 5px;
  height: 30px;
  width: 212px;
  margin: 0 auto 10px auto;
}
</style>
